import React from 'react';
import { Grid, useTheme, useMediaQuery } from '@mui/material';
import { SummaryCards } from './SummaryCards';
import { CaseDistributionCharts } from './CaseDistributionCharts';
import { CaseTrendChart } from './CaseTrendChart';

export const AnalyticsDashboard: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Grid container spacing={isMobile ? 2 : 3}>
      <SummaryCards />
      <CaseDistributionCharts />
      <CaseTrendChart />
    </Grid>
  );
};